import { dropzoneHtml } from "../../Utils/Dropzone/Dropzone";
import { createModal } from "../../Utils/Modals/Modal";


export function newActivationModal(){
    const content = '' +
    '<div id="students-activation">'+
        '<div class="activate-tabs">'+
            '<div class="activate-students-email">'+
                '<div>'+
                    '<p>Hier kannst du Schüler-Accounts per E-Mail freischalten</p>'+
                '</div>'+
                '<div class="row">'+
                    '<div class="col-sm-12 col-lg-9">'+
                        '<div id="activation-fields"></div>'+
                        renderEmailField() + 
                        '</div>'+
                        '<div class="col-sm-12 col-lg-3">'+
                            dropzoneHtml("excel", "Excel-Datei importieren") + 
                            '<div class="success-handler"></div>'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</div>'+
        '</div>'
    // '</div>'


    const submitBtn = {
        text: "Freischalten",
        class: "activate-students",
    }

    const settings = {
        submitBtn: submitBtn,
        centered: false,
        size: 'lg',
        rerender: false,
    }

    createModal("activate-students", "Schüler/-innen aktivieren", content, settings, initModal);
}

export function activationModal(){
    const content = '' +
    '<div id="students-activation">'+
        '<center>'+
            '<div class="a-s-t h4 mb-2">Auf welche Art möchtest du Schüler/-innen aktivieren?</div>'+
            '<span class="me-1">Per E-Mail</span>'+
            '<button type="button" data-type="email" class="btn-students-activate btn btn-light-success text-success btn-circle btn-xl me-1 ms-1 mb-1">'+
                '<i class="fa fa-user"></i>' +
            '</button>'+
            '<button type="button" data-type="anonym" class="btn-students-activate btn btn-light-secondary text-secondary btn-circle btn-xl me-1 mb-1">'+
                '<i class="fa fa-user-secret"></i>' + 
            '</button>'+
            '<span>Anonym</span>'+
        '</center>'+
        '<div class="mb-3 mt-3 dropdown-divider dropdown-students-activate hide"></div>'+
            '<div class="activate-tabs">'+
                '<div class="activate-students-email activate-tab">'+
                    '<center>'+
                        '<p>Hier kannst du Schüler-Accounts per E-Mail freischalten</p>'+
                    '</center>'+
                    '<div class="row">'+
                        '<div class="col-sm-12 col-lg-9">'+
                            '<div id="activation-fields"></div>'+
                            renderEmailField() + 
                            '</div>'+
                            '<div class="col-sm-12 col-lg-3">'+
                                dropzoneHtml("excel", "Excel-Datei importieren") + 
                                '<div class="success-handler"></div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="activate-students-anonym activate-tab">'+
                        '<center>'+
                            '<p>Erstelle anonyme Accounts und verteile sie an deiner Schüler/-innen</p>'+
                        '</center>'+
                    '<div class="row justify-content-center">'+
                        '<div class="col-sm-8 col-md-6 col-lg-4">'+
                            '<div class="m-auto">'+
                                '<input id="count-anonym-students" type="text" value="1"'+
                                'name="count-anonym-students" class="input-sm form-control text-center"'+
                                'style="font-size: 2rem;">'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</div>'+
        '</div>'
    // '</div>'


    const submitBtn = {
        text: "Freischalten",
        class: "activate-students",
    }

    const settings = {
        submitBtn: submitBtn,
        centered: false,
        size: 'lg',
        rerender: false,
    }

    const modal = createModal("activate-students", "Schüler/-innen aktivieren", content, settings, initModal);
    initiateTouchSpin();

}

function initModal(modal){
    // initiateTouchSpin();
    addListener(modal)
}


function initiateTouchSpin(){
    $("input[name='count-anonym-students']").TouchSpin({
        min: 1,
        buttondown_class: "btn btn-xl btn-light-danger text-danger font-medium",
        buttonup_class: "btn btn-xl btn-light-success text-success font-medium",
    });
}

export function refreshEmailFields(){
    const rows = $("#activation-fields").find(".input-group")
    rows.each((ind, obj) => {
        
        let html = '';
        if (ind != rows.length){
            html = renderRemoveButton()
        } else {
            html = renderAddButton();
        }
        $(obj).find(".m-activation-fields").replaceWith($(html))
    })
}

function renderAddButton(){
    const html = '<button class="m-activation-fields add-activation-field btn px-4 btn-light-success text-success font-weight-medium waves-effect waves-light" type="button">'+
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle feather-sm fill-white">'+
        '<circle cx="12" cy="12" r="10"></circle>'+
        '<line x1="12" y1="8" x2="12" y2="16"></line>'+
        '<line x1="8" y1="12" x2="16" y2="12"></line>'+
    '</svg>'+
    '</button>'
    return html;
}

function renderRemoveButton(){
    const html = '<button class="m-activation-fields remove-activation-field btn px-4 btn-light-danger text-danger font-weight-medium waves-effect waves-light" type="button">'+
    '<i class="fa fa-minus"></i>'
    '</button>'
    return html;
}

function renderEmailField(value=''){
    const html = '<div class="input-group mb-2">'+
    '<input type="text" class="form-control student-email check-field" placeholder="E-Mail-Adresse" value="' + value + '">'+
    renderAddButton() + 
    '</div>'
    return html;
}

export function addEmailField(value = ''){
    const html = renderEmailField(value)
    $("#activation-fields").append($(html))
}

function addListener(modal:JQuery){
    modal.on("click", ".add-activation-field", function(){
        const html = renderEmailField();

        $("#activation-fields").append($(html));
        refreshEmailFields();
    })
    modal.on("click", ".remove-activation-field", function(){
        $(this).parents(".input-group").remove();
        refreshEmailFields();
    })
}